import React, {useEffect, useState} from 'react';
import { Bar, defaults, HorizontalBar } from "react-chartjs-2";
import MyTicketSkeleton from "../../module/squareOfSolidarity/component/skeleton/MyTicketSkeleton";

const BarChart = (props) => {
    const [redRaw , setRedRaw] = useState(false)
    defaults.global.defaultFontFamily = 'iranyekan';
    const legend = props.scaleLabel
    const options = {

        maintainAspectRatio: false,
        legend: {
            display: false,
        },
        tooltips: {
            backgroundColor: "#f5f5f5",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
        },
        responsive: true,

        scales: {
            yAxes: [
                {
                    display: true,
                    scaleLabel: {
                        display: legend ? true : false,
                        labelString: legend ? legend[0] : null,
                        fontColor: "rgb(66,66,66)"
                    },
                    gridLines: {
                        drawBorder: true,
                        color: "rgba(225,78,202,0.1)",
                        zeroLineColor: "rgba(88,88,88,0.9)",
                    },
                    ticks: {
                        suggestedMin: 0,
                        suggestedMax: 0,
                        padding: 20,
                        fontColor: "#000",
                        fontSize: 12
                    },
                },
            ],
            xAxes: [
                {
                    scaleLabel: {
                        display: legend ? true : false,
                        labelString: legend ? legend[1] : null,
                        fontColor: "rgb(36,36,36)"

                    },
                    gridLines: {
                        drawBorder: true,
                        color: "rgba(225,78,202,0.1)",
                        zeroLineColor: "rgba(88,88,88,0.9)",
                    },
                    ticks: {
                        suggestedMin: 0,
                        suggestedMax: 0,
                        padding: 20,
                        fontColor: "#000",
                        fontSize: 12
                    },
                },
            ],
        },
    }
    useEffect(()=>{
        setTimeout(()=>{
            setRedRaw(true)
        },50)
    },[])
    return (
        <>
            {props.data ? props.type === 'h' ?
                <HorizontalBar
                    data={props.data}
                    redraw={redRaw}
                    options={options}
                /> : <Bar
                    data={props.data}
                    redraw={redRaw}
                    options={options}
                />
                : <MyTicketSkeleton type={'fas fa-chart-bar'}/>
            }
        </>
    );
}

export default BarChart;